import { Users } from 'lucide-react';
import { Customer, Mold } from '../../types/mold';

const adjustColor = (color: string, amount: number): string => {
    // Function to adjust color brightness
    let usePound = false;
    if (color[0] === "#") {
        color = color.slice(1);
        usePound = true;
    }

    const num = parseInt(color, 16);
    let r = (num >> 16) + amount;
    let g = ((num >> 8) & 0x00FF) + amount;
    let b = (num & 0x0000FF) + amount;

    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));

    return (usePound ? "#" : "") + (r << 16 | g << 8 | b).toString(16).padStart(6, '0');
};

const CustomerCodeLabel = ({ customer }: { customer: Customer }) => {
    const customerTextColor = customer.color === null ? '#ffffff' : adjustColor(customer.color, -150);

    if (customer.color !== null)

        return (<div className={`flex items-center rounded-full text-base gap-1`} style={{ backgroundColor: customer.color }}>
            <Users className="ml-2 w-4 h-4" style={{ color: customerTextColor }} />
            <span className="pr-2.5 py-1 font-medium" style={{ color: customerTextColor }}>
                {customer.code}
            </span>
        </div>)

    return (<div className="flex items-center bg-indigo-100 text-indigo-700 rounded-full text-base gap-1">
        <Users className="ml-2 w-4 h-4 text-indigo-500" />
        <span className="pr-2.5 py-1 font-medium">
            {customer.code}
        </span>
    </div>);
}

export default CustomerCodeLabel;